export const EXTERNAL_LEAGUE_CODE = "EXT_COMPETITIONS";
